import React from 'react';
import { FormattedMessage } from "react-intl";
import Esoko from '../../assets/img/auth/esoko.svg';


const AuthHeader = props => {
    const screen = props.screen ? props.screen : window.location.pathname.split('/')[2];

    return (
        <div id="auth__header">
            <img src={Esoko} alt="Esoko" />
            <div>&nbsp;</div>

            <div className="title">
                {screen === 'signin' && (<FormattedMessage id="Signin.Header.Title" defaultMessage="Sign into your account" />)}

                {['signup', 'invitation'].includes(screen) === true && (
                    <FormattedMessage id="Signup.Header.Title" defaultMessage="Create an account. Absolutely free!" />
                )}
            </div>
            <p>&nbsp;</p>
        </div>
    )
};

export default AuthHeader;